import { MARQUEE } from "../../data";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div className="bg-ocean-dark py-5 overflow-hidden border-y border-gold/20" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {items.map((t, i) => (
          <span key={i} className="flex items-center text-white/70 font-serif italic text-xl sm:text-2xl px-8">
            {t}
            <span className="ml-8 text-gold not-italic">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
